export default "__VITE_ASSET__CEVlCrL8__"